// Module
var code = `<div class="webhook-created-screen">
    <div class="webhook-created-screen-body">
        <div class="webhook-created-screen-body-information">
            <div class="webhook-created-screen-body-information-label">{{nameLabel}}</div>
            <div class="webhook-created-screen-body-information-value">{{nameValue}}</div>

            <div class="webhook-created-screen-body-information-label">{{apiKeyLabel}}</div>
            <div class="webhook-created-screen-body-information-value">
                <reactSecretField
                    value="{{apiKeyValue}}"
                    isVisible="{{apiKeyValueIsVisible}}"
                    visibleButtonTooltip="{{apiKeyValueIsVisible ? hideKeyTooltip : showKeyTooltip}}"
                    copyButtonTooltip="{{copyButtonTooltip}}"
                    on-onVisibleButtonClick="@this.onApiKeyValueToggleVisibility()"
                    on-onCopyButtonClick="@this.onCopyToClipboard(\$1)"
                />
            </div>

            <div class="webhook-created-screen-body-information-label">{{secretKeyLabel}}</div>
            <div class="webhook-created-screen-body-information-value">
                <reactSecretField
                    value="{{secretKeyValue}}"
                    isVisible="{{secretKeyValueIsVisible}}"
                    visibleButtonTooltip="{{secretKeyValueIsVisible ? hideKeyTooltip : showKeyTooltip}}"
                    copyButtonTooltip="{{copyButtonTooltip}}"
                    on-onVisibleButtonClick="@this.onSecretKeyValueToggleVisibility()"
                    on-onCopyButtonClick="@this.onCopyToClipboard(\$1)"
                />
            </div>

            {{#if webhookUrlValue}}
            <div class="webhook-created-screen-body-information-label">{{webhookUrlLabel}}</div>
            <div class="webhook-created-screen-body-information-value">
                <reactSecretField
                    value="{{webhookUrlValue}}"
                    isUrl="true"
                    isVisible="{{webhookUrlIsVisible}}"
                    visibleButtonTooltip="{{webhookUrlIsVisible ? hideKeyTooltip : showKeyTooltip}}"
                    copyButtonTooltip="{{copyButtonTooltip}}"
                    on-onVisibleButtonClick="@this.onWebhookUrlToggleVisibility()"
                    on-onCopyButtonClick="@this.onCopyToClipboard(\$1)"
                />
            </div>
            {{/if}}
        </div>
        <div class="webhook-created-screen-body-warning">
            <notificationMessageRactive type="warning" text="{{warningLabel}}" />
        </div>
        <div class="webhook-created-screen-body-code-snippet">
            <reactWebhooksCodeSnippet webhookUrl="{{webhookBrandingUrl}}" />
        </div>
        {{#if viewApiDocsUrl}}
            <div class="webhook-created-screen-body-view-api-docs">
                <reactLink href="{{viewApiDocsUrl}}" text="{{viewApiDocsText}}" />
            </div>
        {{/if}}
    </div>
    <div class="webhook-created-screen-footer">
        <reactButton type="{{okButtonType}}" text="{{okButtonText}}" on-onClick="@this.onOkButtonClicked()" />
    </div>
</div>
`;
// Exports
export default code;